/**
 * TanStack Query hook for fetching saved Slide Sense collections.
 */

import { useQuery } from "@tanstack/react-query"

import type { SlideSenseCollection } from "../types"

import { fetchCollections } from "../api"

/**
 * Fetch all saved collections for the current user.
 */
export function useCollections() {
  return useQuery<SlideSenseCollection[]>({
    queryKey: ["slide-sense", "collections"],
    queryFn: () => fetchCollections(),
  })
}
